import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getConsentSnapshot, onCookieConsentChange } from "../utils/cookieConsent";
import { syncConsentMode, trackPageView } from "../analytics/tracker";

function useAnalytics() {
  const location = useLocation();
  const [consent, setConsent] = useState(() => getConsentSnapshot());

  useEffect(() => {
    const current = getConsentSnapshot();
    setConsent(current);
    syncConsentMode(current);

    return onCookieConsentChange((consent) => {
      const next = {
        ...getConsentSnapshot(),
        ...(consent || {}),
      };
      setConsent(next);
      syncConsentMode(next);
    });
  }, []);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search || ""}`);
  }, [location.pathname, location.search, consent.analytics, consent.ads]);
}

export default useAnalytics;
